import React from 'react';
import { Modal, Button } from 'antd';
import './ReferModal.css';
interface ReferModalProps {
  isOpen: boolean;
  title: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  description: string | React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  confirmText?: string;
  confirmButtonType?: 'primary' | 'default' | 'dashed' | 'link' | 'text';
}

const ReferModal: React.FC<ReferModalProps> = ({
  isOpen,
  title,
  contactName,
  contactEmail,
  contactPhone,
  description,
  onCancel,
  onConfirm,
  confirmText = 'Delete',
  confirmButtonType = 'primary',
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      closable={true}
      closeIcon={<span className="close-icon">×</span>}
      className="refer-modal"
      width={400}
      centered
    >
      <div className="refer-modal-content">
        <div className="refer-modal-text">
            <h3>{title}</h3>
            <p>{description}</p>
            <div>
                Contact:
                <span>{contactName}</span>
            </div>
            <div>
                Email: 
                <a href="mailto:info@thunderbirdmortgage.com">{contactEmail}</a>
            </div>
            <div>
                Phone: 
                <a href="tel:888-555-5555">{contactPhone}</a>
            </div>
        </div>
        <div className="refer-modal-footer">
          <Button
            type={confirmButtonType}
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ReferModal;